import { render, staticRenderFns } from "./authredirect.vue?vue&type=template&id=4dd74f21"
import script from "./authredirect.vue?vue&type=script&lang=js"
export * from "./authredirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dd74f21')) {
      api.createRecord('4dd74f21', component.options)
    } else {
      api.reload('4dd74f21', component.options)
    }
    module.hot.accept("./authredirect.vue?vue&type=template&id=4dd74f21", function () {
      api.rerender('4dd74f21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/login/authredirect.vue"
export default component.exports